export default __webpack_public_path__ + "static/media/etc05.2798b8c6.png";